import React from 'react';
import background from '../../assets/co2.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoCO2 extends React.Component {
  render () {
    return(


    <ReusableInfoCard     

    tag="ATMOSPHERE"
    description="Carbon Dioxide"
        
    paragraph="Since the industrial revolution, the atmospheric concentration of carbon dioxide has increased from 280 to over 400 parts per million due to the burning of fossil fuels such as coal, gas, and oil, along with land use change."
    
    background= {background}
    />
  
  );
 }
}
export default InfoCO2;